<template>
  <div class="event-card" :class="[`event-card--${card.kind}`, { 'event-card--down': !faceUp, 'event-card--people': people }]" :style="people ? { '--people': people.colour } : null">
    <div class="event-card__inner">
      <div class="event-card__back">
        <span class="event-card__back-mark">✦</span>
      </div>
      <div class="event-card__face">
        <span class="event-card__kind">{{ KIND_LABEL[card.kind] || card.kind }}</span>
        <h3 class="event-card__name">{{ card.name }}<template v-if="event?.rivalName"> - {{ event.rivalName }}</template></h3>
        <!-- WHO they are comes first, so two peoples' cards do not read the
             same (Matt, playtest 10: "the paragraph describing the Painted
             Folk and the Iron Sons is the same"). -->
        <p v-if="people" class="event-card__people event-card__people--lead"><span class="event-card__swatch" aria-hidden="true" />{{ people.blurb }} <strong>{{ people.way }}</strong></p>
        <p class="event-card__text" :class="{ 'event-card__text--after': people }">{{ card.text }}</p>
        <p v-if="event?.branch" class="event-card__branch">{{ event.branch }}</p>
        <ul v-if="event?.resolved && event.lines?.length" class="event-card__lines">
          <li v-for="line in shown" :key="line.key" :class="{ 'is-up': line.up, 'is-down': line.down }">
            <Pip v-if="line.pip" :kind="line.pip.kind" :n="line.pip.n" signed />
            <template v-else>{{ line.text }}</template>
          </li>
        </ul>
        <p v-else-if="event?.resolved && !event.lines?.length && !event.branch" class="event-card__branch">Nothing changes.</p>
        <p v-else-if="event && !event.resolved" class="event-card__branch event-card__branch--waiting">Vote on your phones.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { EVENTS } from '@/engine/cards';
import { rivalColour, rivalBlurb, wayText } from '@/engine/rivals';
import Pip from './Pip.vue';
import { RESOURCES } from './resourceArt';

// "+2 food" is a number and its thing, so it draws as a pip like every other
// number in the game (house style rule 6). Anything that is a sentence
// rather than a delta stays a sentence.
const DELTA = /^([+-]\d+) ([a-z]+)$/;
const KIND = { people: 'population', person: 'population' };

const KIND_LABEL = {
  weather: 'Weather', people: 'People', omen: 'Omen', civic: 'Civic', echo: 'Echo', goal: 'The Vision',
  year: 'The Year', harvest: 'Harvest', midwinter: 'Midwinter', age: 'A New Age',
};

export default {
  name: 'EventCard',
  components: { Pip },
  props: {
    cardId: { type: String, required: true },
    event: { type: Object, default: null },
    faceUp: { type: Boolean, default: true },
  },
  data() { return { KIND_LABEL }; },
  computed: {
    people() {
      const id = this.event?.rival;
      return id ? { colour: rivalColour(id), blurb: rivalBlurb(id), way: wayText(id) } : null;
    },
    card() { return EVENTS[this.cardId] || { kind: 'omen', name: '?', text: '' }; },
    shown() {
      return (this.event?.lines || []).map((text, i) => {
        const m = DELTA.exec(text);
        const kind = m && (KIND[m[2]] || m[2]);
        return {
          key: `${i}-${text}`,
          text,
          up: text.startsWith('+'),
          down: text.startsWith('-'),
          pip: kind && RESOURCES[kind] ? { kind, n: Number(m[1]) } : null,
        };
      });
    },
  },
};
</script>
